import en from './en';

type Translation = {
  [key in keyof typeof en]: string;
};

type QueryTranslations = {
  [lang: string]: Translation;
};

export const queryTranslations: QueryTranslations = {
  en,
};
